// Detect which "portal" the app is being served as, from the subdomain.
// In production, point admin.tudominio.com and restaurant.tudominio.com to the app.
// In preview (no subdomains), use ?portal=admin | ?portal=restaurant to test.
export function getPortal() {
  try {
    const params = new URLSearchParams(window.location.search);
    const q = params.get("portal");
    if (q === "admin" || q === "restaurant") return q;
    const sub = window.location.hostname.split(".")[0].toLowerCase();
    if (sub === "admin") return "admin";
    if (sub === "restaurant" || sub === "restaurante") return "restaurant";
  } catch (_) {}
  return null;
}
